import Loading from '@app/react-common/Loading';
import type { AdminBlastDoc } from '@bb/domain/dist/schemas';
import { Flex, Paragraph } from '@bb/elements-web';
import type { AnnouncementType } from 'api/AnnouncementController';
import React from 'react';
import styled from 'styled-components';
import AnnouncementItem from './AnnouncementItem';

type AnnouncementListProps = {
  announcements: AdminBlastDoc[];
  type: AnnouncementType;
  isLoading: boolean;
  deleteAnnouncement: (
    announcementId: string,
  ) => (event: React.MouseEvent) => Promise<void>;
};

const AnnouncementList = (props: AnnouncementListProps) => {
  const { announcements, type, isLoading, deleteAnnouncement } = props;
  return (
    <StyledAnnouncementListContainer data-cy="announcement-list">
      {isLoading && (
        <StyledLoadingContainer>
          <Loading size={'fa-3x'} />
        </StyledLoadingContainer>
      )}
      <Flex wrap="wrap">
        {!announcements.length && !isLoading && (
          <Paragraph>No Announcements Found</Paragraph>
        )}
        {announcements.map(announcement => (
          <AnnouncementItem
            key={announcement.id}
            deleteAnnouncement={deleteAnnouncement}
            type={type}
            announcement={announcement}
          />
        ))}
      </Flex>
    </StyledAnnouncementListContainer>
  );
};

const StyledAnnouncementListContainer = styled.div`
  position: relative;
  min-width: 100%;
`;

const StyledLoadingContainer = styled(Flex)`
  position: absolute;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8);
  z-index: 10;
`;

export default AnnouncementList;
